
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"42","height":"40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.809 12.711l-10.245-.736a.549.549 0 01-.48-.35l-3.902-9.502A3.376 3.376 0 0021.007 0c-1.421 0-2.628.813-3.176 2.131l-3.91 9.51a.574.574 0 01-.48.351l-10.228.736c-1.386.077-2.567.985-3.021 2.32a3.355 3.355 0 001.018 3.707l7.917 6.54c.163.136.24.359.189.564l-2.414 9.878a3.339 3.339 0 00.54 2.92A3.414 3.414 0 0010.136 40c.65 0 1.284-.197 1.806-.548l8.653-5.384a.564.564 0 01.59 0l8.739 5.367a3.27 3.27 0 001.823.565c.984 0 1.96-.47 2.593-1.267.66-.822.899-1.892.66-2.962l-2.423-9.903a.577.577 0 01.188-.574l8.037-6.557c1.078-.924 1.464-2.345 1.01-3.697-.445-1.336-1.635-2.252-3.004-2.329zm.659 4.409l-8.02 6.548a2.668 2.668 0 00-.898 2.696l2.422 9.887c.128.582-.103.984-.257 1.172-.24.3-.599.488-.958.488-.223 0-.446-.068-.685-.23l-8.773-5.393a2.663 2.663 0 00-2.799.008l-8.687 5.401c-.556.368-1.3.206-1.694-.308-.163-.214-.334-.582-.18-1.121l2.422-9.912a2.674 2.674 0 00-.89-2.68l-7.9-6.53c-.625-.54-.453-1.233-.385-1.43.069-.197.351-.856 1.173-.899l10.244-.736a2.652 2.652 0 002.269-1.644l3.91-9.51c.318-.77 1.028-.83 1.233-.83.206 0 .916.06 1.233.83l3.911 9.51a2.652 2.652 0 002.268 1.644l10.262.745c.805.042 1.087.701 1.156.898.05.18.222.873-.377 1.396z","fill":"#4A4A4A","fill-rule":"nonzero","opacity":".522"}})])
          )
        }
      }
    